// Tickable Mail: editor texts (nl)
export default {
  // templates list
  "mail_tpl_intro": "De mails die je verstuurt, vanuit een automatische mail of een nieuwsbrief. Pas ze aan zoals jij wilt.",
  "mail_tpl_new": "Nieuw ontwerp",
  "mail_tpl_load_failed": "De ontwerpen konden niet geladen worden",
  "mail_tpl_system": "Systeemmails",
  "mail_tpl_system_intro": "Deze mails gaan vanzelf. Zolang je niks aanpast, krijgen bezoekers onze standaardtekst in jouw huisstijl.",
  "mail_tpl_default": "Standaard",
  "mail_tpl_customized": "Aangepast, bijgewerkt op {date}",
  "mail_tpl_customize": "Aanpassen",
  "mail_tpl_edit": "Bewerken",
  "mail_tpl_view": "Bekijken",
  "mail_tpl_reset": "Terug naar standaard",
  "mail_tpl_reset_title": "Terug naar standaard?",
  "mail_tpl_reset_confirm": "Je aanpassingen aan '{name}' gaan weg en bezoekers krijgen weer de standaardmail.",
  "mail_tpl_own": "Jouw ontwerpen",
  "mail_tpl_empty": "Nog geen eigen ontwerpen. Begin met een voorbeeld, dan heb je zo iets moois staan.",
  "mail_tpl_kind": "Soort mail",
  "mail_tpl_kind_transactional": "Over een bestelling",
  "mail_tpl_kind_marketing": "Nieuwsbrief",
  "mail_tpl_kind_transactional_hint": "Over een bestelling of bezoek. Gaat naar iedereen die het aangaat.",
  "mail_tpl_kind_marketing_hint": "Nieuws en aanbiedingen. Gaat alleen naar mensen die toestemming gaven.",
  "mail_tpl_updated": "bijgewerkt op {date}",
  "mail_tpl_duplicate": "Kopiëren",
  "mail_tpl_copy_of": "{name} (kopie)",
  "mail_tpl_delete": "Verwijderen",
  "mail_tpl_delete_confirm": "'{name}' gaat weg. Dat kun je niet terugdraaien.",
  "mail_tpl_delete_failed": "Verwijderen lukte niet",
  "mail_tpl_in_use": "Dit ontwerp wordt nog gebruikt",
  "mail_tpl_in_use_detail": "Het zit in: {flows}. Haal het daar eerst weg, dan kun je het verwijderen.",
  "mail_tpl_start_from": "Waar wil je mee beginnen?",
  "mail_tpl_blank": "Leeg",
  "mail_tpl_blank_hint": "Alleen een tekstblok, de rest bouw je zelf",
  "mail_tpl_name": "Naam",
  "mail_tpl_name_required": "Geef je ontwerp een naam, dan vind je het straks terug.",
  "mail_tpl_create": "Maken",
  "mail_tpl_create_failed": "Het ontwerp kon niet gemaakt worden",

  // editor: page
  "mail_editor_back": "Terug naar ontwerpen",
  "mail_editor_not_found": "Dit ontwerp bestaat niet (meer)",
  "mail_editor_not_found_text": "Misschien is hij verwijderd, of hoort hij bij een andere organisatie.",
  "mail_editor_read_only": "Alleen bekijken",
  "mail_editor_read_only_text": "Je kunt deze mail bekijken en een test naar jezelf sturen. Aanpassen kan alleen met het recht om mails te bewerken.",
  "mail_editor_unsaved": "Niet opgeslagen",
  "mail_editor_preview": "Voorbeeld",
  "mail_editor_send_test": "Stuur test naar mij",
  "mail_editor_test_sent": "Testmail verstuurd",
  "mail_editor_test_sent_to": "Kijk even in je inbox: {email}",
  "mail_editor_test_failed": "De testmail kon niet verstuurd worden",
  "mail_editor_save": "Opslaan",
  "mail_editor_saved": "Opgeslagen",
  "mail_editor_save_failed": "Opslaan lukte niet",
  "mail_editor_fix_first": "Er klopt nog iets niet. Kijk even naar de rode meldingen.",
  "mail_editor_leave_confirm": "Je hebt wijzigingen die nog niet zijn opgeslagen. Toch weggaan?",
  "mail_editor_preheader": "Preheader",
  "mail_editor_inspector": "Instellingen van het blok",
  "mail_editor_nothing_selected": "Klik op een blok in de mail om het aan te passen.",
  "mail_editor_keyboard_hint": "Met het toetsenbord: Tab naar een blok, Enter om het te kiezen, Alt + pijltje omhoog of omlaag om het te verplaatsen.",
  "mail_editor_small_screen": "De editor heeft een groter scherm nodig, zoals een laptop. Hier zie je hoe de mail eruitziet, en je kunt een test naar jezelf sturen.",
  "mail_editor_retry": "Opnieuw proberen",

  // palette and canvas
  "mail_editor_palette": "Blokken",
  "mail_editor_palette_content": "Inhoud",
  "mail_editor_palette_dynamic": "Uit je bestelling en activiteiten",
  "mail_editor_palette_hint": "Klik om een blok onder het gekozen blok te zetten, of sleep het naar de plek waar je het wilt.",
  "mail_editor_blocks": "Blokken in de mail",
  "mail_editor_block_tools": "Blok bewerken",
  "mail_editor_drag": "Slepen",
  "mail_editor_drag_hint": "Sleep om te verplaatsen",
  "mail_editor_move_up": "Omhoog",
  "mail_editor_move_down": "Omlaag",
  "mail_editor_duplicate": "Dupliceren",
  "mail_editor_delete": "Verwijderen",
  "mail_editor_required_block": "Deze mail heeft dit blok nodig, dus het kan niet weg.",
  "mail_editor_has_error": "hier klopt iets niet",
  "mail_editor_canvas_empty": "Je mail is nog leeg. Kies links een blok om te beginnen.",
  "mail_editor_canvas_empty_readonly": "Deze mail heeft nog geen blokken.",
  "mail_editor_footer_marketing": "Postadres en afmeldlink komen hier vanzelf",
  "mail_editor_empty_heading": "Typ hier je kop",
  "mail_editor_empty_text": "Typ hier je tekst",
  "mail_editor_empty_image": "Kies een afbeelding",
  "mail_editor_sample": "Voorbeeld",
  "mail_editor_sample_upcoming": "Vult zich vanzelf",
  "mail_editor_sample_event": "Naam van je activiteit",
  "mail_editor_sample_when": "za 14 juni · 20:00",
  "mail_editor_sample_where": "Locatie · Straat 1, Plaats",
  "mail_editor_sample_ticket": "Regulier",
  "mail_editor_sample_ticket_child": "Kind",
  "mail_editor_sample_promo": "Evenement {n}",

  // block names
  "mail_editor_block_heading": "Kop",
  "mail_editor_block_text": "Tekst",
  "mail_editor_block_image": "Afbeelding",
  "mail_editor_block_button": "Knop",
  "mail_editor_block_divider": "Lijn",
  "mail_editor_block_spacer": "Witruimte",
  "mail_editor_block_event": "Evenement",
  "mail_editor_block_tickets": "Tickets",
  "mail_editor_block_payment_link": "Betaallink",
  "mail_editor_block_order_link": "Link naar bestelling",
  "mail_editor_block_extras": "Extra's bijkopen",
  "mail_editor_block_shop_button": "Knop naar shop",
  "mail_editor_block_event_promo": "Meer activiteiten",

  // inspector
  "mail_editor_field_heading": "Kop",
  "mail_editor_field_size": "Grootte",
  "mail_editor_level_1": "Groot",
  "mail_editor_level_2": "Klein",
  "mail_editor_field_text": "Tekst",
  "mail_editor_field_image": "Afbeelding",
  "mail_editor_field_alt": "Beschrijving (alt-tekst)",
  "mail_editor_field_alt_hint": "Veel mailprogramma's laten afbeeldingen eerst niet zien. Beschrijf kort wat erop staat.",
  "mail_editor_field_image_link": "Link bij klikken (mag leeg)",
  "mail_editor_field_width": "Breedte",
  "mail_editor_field_width_full": "Volle breedte",
  "mail_editor_field_label": "Tekst op de knop",
  "mail_editor_field_caption": "Kopje",
  "mail_editor_field_note": "Regel onder de knop",
  "mail_editor_field_pdf_label": "Link naar de PDF",
  "mail_editor_pay_before_hint": "Zet de variabele Betalen vóór erin, dan staat de datum erbij.",
  "mail_editor_field_href": "Link",
  "mail_editor_field_href_hint": "Begint met https:// of mailto:, of kies een variabele.",
  "mail_editor_divider_hint": "Een dunne lijn om delen van je mail uit elkaar te houden.",
  "mail_editor_field_space": "Hoeveel ruimte",
  "mail_editor_space_s": "Klein",
  "mail_editor_space_m": "Middel",
  "mail_editor_space_l": "Groot",
  "mail_editor_event_hint": "Toont de activiteit van de ontvanger, met beeld, titel en locatie en de datum en tijd van het eigen tijdslot.",
  "mail_editor_tickets_hint": "Toont wat er besteld is, met een knop naar de bestelling. In de bevestiging zitten de tickets ook als PDF in de bijlage.",
  "mail_editor_payment_link_hint": "Toont de gereserveerde tickets met een knop om te betalen.",
  "mail_editor_order_link_hint": "Een knop naar de bestelpagina, waar de tickets staan.",
  "mail_editor_extras_hint": "De extra's die nog te koop zijn, met een knop om ze toe te voegen. Zonder extra's blijft het blok weg.",
  "mail_editor_sample_extra": "Borrelarrangement",
  "mail_editor_sample_extra_parking": "Parkeren",
  "mail_editor_shop_button_hint": "Een knop naar je shop, of naar de activiteit als de mail over één activiteit gaat.",
  "mail_editor_field_promo_title": "Titel",
  "mail_editor_field_promo_mode": "Welke activiteiten",
  "mail_editor_promo_upcoming": "Eerstvolgende",
  "mail_editor_promo_pick": "Zelf kiezen",
  "mail_editor_promo_upcoming_hint": "Bij het versturen kiezen we per ontvanger de eerstvolgende activiteiten.",
  "mail_editor_promo_pick_hint": "Afgelopen activiteiten, en uitverkochte zonder wachtlijst, laten we vanzelf weg.",
  "mail_editor_field_promo_events": "Evenementen",
  "mail_editor_field_promo_events_placeholder": "Kies activiteiten",
  "mail_editor_field_promo_max": "Hoeveel maximaal",
  "mail_editor_field_promo_skip_bought": "Sla activiteiten over waar de ontvanger al tickets voor heeft",
  "mail_editor_field_promo_waitlist": "Uitverkocht? Toon de wachtlijst als die aan staat",

  // text editor
  "mail_editor_text_toolbar": "Opmaak",
  "mail_editor_bold": "Vet",
  "mail_editor_italic": "Cursief",
  "mail_editor_underline": "Onderstrepen",
  "mail_editor_link": "Link",
  "mail_editor_bullets": "Opsomming",
  "mail_editor_numbers": "Genummerde lijst",
  "mail_editor_link_prompt": "Link (https:// of mailto:). Leeg maken haalt de link weg.",
  "mail_editor_insert_variable": "Variabele",

  // image upload
  "mail_editor_image_choose": "Afbeelding kiezen",
  "mail_editor_image_replace": "Vervangen",
  "mail_editor_image_advice": "JPG, PNG of GIF. We maken hem zelf kleiner.",
  "mail_editor_image_wrong_type": "Dit bestand werkt niet in mails. Kies een JPG, PNG of GIF.",
  "mail_editor_image_gif_too_big": "Deze GIF is groter dan 1 MB. Dat laadt traag in een mail, kies een kleinere.",
  "mail_editor_image_too_big": "Ook verkleind is deze afbeelding nog groter dan 2 MB. Kies een kleinere.",

  // languages and translation
  "mail_editor_lang_label": "Taal van de mail",
  "mail_editor_lang_source": "bron",
  "mail_editor_lang_single": "Wil je ook in andere talen mailen? Zet ze aan onder",
  "mail_editor_lang_todo": "{n} teksten nog niet vertaald of verouderd",
  "mail_editor_translate": "Vertalen",
  "mail_editor_translate_stale": "{n} velden verouderd · alles bijwerken",
  "mail_editor_translate_done": "Alles is vertaald",
  "mail_editor_translate_manual": "ook handmatige teksten ({n})",
  "mail_editor_translate_ok": "{n} teksten vertaald",
  "mail_editor_translate_partial": "{done} teksten vertaald, {failed} niet. Kijk die even zelf na.",
  "mail_editor_translate_failed": "Vertalen lukte niet",
  "mail_editor_translate_rejected": "De vertaling klopte niet met de brontekst (bijvoorbeeld een variabele of link die anders was).",
  "mail_editor_ai_tag_hint": "Automatisch vertaald. Pas je het aan, dan blijft jouw tekst staan.",
  "mail_editor_update": "Bijwerken",
  "mail_editor_not_translated": "Nog niet vertaald",
  "mail_editor_uses_source": "Zolang dit leeg is, krijgen bezoekers de brontekst.",

  // preview
  "mail_editor_preview_width": "Breedte van het voorbeeld",
  "mail_editor_preview_desktop": "Desktop",
  "mail_editor_preview_mobile": "Mobiel",
  "mail_editor_preview_failed": "Het voorbeeld kon niet geladen worden",

  // validation
  "mail_editor_error_subject": "Vul een onderwerp in.",
  "mail_editor_error_required_tickets": "De ticketbevestiging heeft een blok Tickets nodig.",
  "mail_editor_error_required_payment_link": "Deze mail heeft een blok Betaallink nodig.",
  "mail_editor_error_heading": "Deze kop is nog leeg.",
  "mail_editor_error_image_src": "Kies een afbeelding.",
  "mail_editor_error_image_alt": "Beschrijf kort wat er op de afbeelding staat.",
  "mail_editor_error_button_label": "Zet een tekst op de knop.",
  "mail_editor_error_href": "Deze link werkt niet. Begin met https:// of mailto:, of kies een variabele.",
  "mail_editor_error_promo_events": "Kies minstens één activiteit.",

  // Return path, lock and tests (phase 2b)
  "mail_editor_back_generic": "Terug",
  "mail_editor_back_campaign": "Terug naar je bericht",
  "mail_editor_locked_scheduled": "Deze mail is ingepland en ligt nu vast. Wil je nog iets aanpassen? Annuleer dan eerst de verzending.",
  "mail_editor_locked_sent": "Deze mail is verstuurd en ligt vast, zodat je altijd ziet wat mensen kregen.",
  "mail_editor_locked_link": "Naar het bericht",
  "mail_editor_test_to": "Naar {email}",
  "mail_editor_block_discount_code": "Persoonlijke code",
  "mail_editor_discount_code_hint": "Iedereen krijgt hier een eigen code van de korting van deze uitnodiging, die één keer werkt, met een knop die hem in de shop invult.",
}
